import './WhoWeWorkWith.css'

const sectors = [
  { icon: <FinanceIcon />, label: 'Financial Services' },
  { icon: <ManufacturingIcon />, label: 'Manufacturing & Logistics' },
  { icon: <ProfServicesIcon />, label: 'Professional Services' },
  { icon: <RetailIcon />, label: 'Retail & Commerce' },
]

export default function WhoWeWorkWith() {
  return (
    <section className="who section" id="sectors">
      <div className="container">
        <div className="who__header">
          <span className="section-eyebrow">Who We Work With</span>
          <h2 className="section-heading">
            Sector expertise that matters
          </h2>
          <p className="section-subtext" style={{ marginTop: '0.75rem' }}>
            We bring deep domain knowledge to engagements — understanding compliance constraints in
            financial services, operational complexity in manufacturing, and the data realities
            that differ across every sector.
          </p>
        </div>

        <div className="who__sectors">
          {sectors.map((s, i) => (
            <div className="who__sector" key={i}>
              <div className="who__sector-icon">{s.icon}</div>
              <span className="who__sector-label">{s.label}</span>
            </div>
          ))}
        </div>

        <p className="who__geography">
          <LocationIcon />
          Mid-market businesses in Leeds, Manchester, and across the North of England
        </p>
      </div>
    </section>
  )
}

function FinanceIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="7" width="20" height="14" rx="2"/>
      <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
      <line x1="12" y1="12" x2="12" y2="16"/>
      <line x1="10" y1="14" x2="14" y2="14"/>
    </svg>
  )
}

function ManufacturingIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 20h20"/>
      <path d="M5 20V8l4 4V8l4 4V8l4 4V20"/>
      <path d="M2 8h3"/>
    </svg>
  )
}

function ProfServicesIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
      <circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  )
}

function RetailIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
      <line x1="3" y1="6" x2="21" y2="6"/>
      <path d="M16 10a4 4 0 0 1-8 0"/>
    </svg>
  )
}

function LocationIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
      <circle cx="12" cy="9" r="2.5"/>
    </svg>
  )
}
